import {WebTracerProvider} from '@opentelemetry/sdk-trace-web';
import {BatchSpanProcessor} from '@opentelemetry/sdk-trace-base';
import {OTLPTraceExporter} from '@opentelemetry/exporter-trace-otlp-http';
import {FetchInstrumentation} from '@opentelemetry/instrumentation-fetch';
import {UserInteractionInstrumentation} from '@opentelemetry/instrumentation-user-interaction';
import {XMLHttpRequestInstrumentation} from '@opentelemetry/instrumentation-xml-http-request';
import {registerInstrumentations} from '@opentelemetry/instrumentation';
import {LoggerProvider, SimpleLogRecordProcessor} from '@opentelemetry/sdk-logs';
import {OTLPLogExporter} from '@opentelemetry/exporter-logs-otlp-http';
import {logs} from '@opentelemetry/api-logs';
import {resourceFromAttributes} from '@opentelemetry/resources';
import {
    ATTR_SERVICE_NAME,
    ATTR_SERVICE_VERSION,
    ATTR_DEPLOYMENT_ENVIRONMENT_NAME
} from '@opentelemetry/semantic-conventions';


import CustomSpanProcessor from "./signozInstrumentEnrichment";


const loggerProvider = new LoggerProvider({
    resource: resourceFromAttributes({
        [ATTR_SERVICE_NAME]: 'safe-app-vuejs',
        'service.namespace': 'safe-app',
        [ATTR_SERVICE_VERSION]: 'v4.0.5.20',
        [ATTR_DEPLOYMENT_ENVIRONMENT_NAME]: 'production',
    }),
    processors: [
        new SimpleLogRecordProcessor(
            new OTLPLogExporter(
                {
                    url: 'https://tm.tumatext.co.ke/log',
                    headers: {}
                })
        ),
    ],
});

logs.setGlobalLoggerProvider(loggerProvider);

const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
        [ATTR_SERVICE_NAME]: 'safe-app-vuejs',
        'service.namespace': 'safe-app',
        [ATTR_SERVICE_VERSION]: 'v4.0.5.20',
        [ATTR_DEPLOYMENT_ENVIRONMENT_NAME]: 'production',
    }),
    spanProcessors: [new BatchSpanProcessor(new OTLPTraceExporter({
        url: 'https://tm.tumatext.co.ke/trace',
        headers: {}
    })), CustomSpanProcessor],
});

provider.register();

registerInstrumentations({
    instrumentations: [
        new FetchInstrumentation({
            // Selects which backend servers are allowed to receive trace headers for linking traces across services.
            // Using /.*/ acts as a wildcard. For safer usage in production, replace with specific domains:
            // e.g. propagateTraceHeaderCorsUrls: [/api\.example\.com/, /my-backend\.internal/]
            propagateTraceHeaderCorsUrls: /.*/,
        }),
        new UserInteractionInstrumentation({
            eventNames: ['click', 'input', 'submit'],
        }),
        new XMLHttpRequestInstrumentation({
            propagateTraceHeaderCorsUrls: /.*/,
        }),
    ],
});